import { IWLayoutSettings, IWSettings } from "@/models/interact-web-settings/interfaces/IWSettings";
import { IWSettingsDTO } from "api/interfaces/iw-settings-dto";

// Mapper to set default values if layouts is undefined, or if any of the layout settings are undefined
const mapLayoutSettings = (data: IWLayoutSettings): IWLayoutSettings => {
  return {
    levelLabel: data?.levelLabel ?? "Level",
    sectionLabel: data?.sectionLabel ?? "Section",
    rowLabel: data?.rowLabel ?? "Row/Box",
    seatLabel: data?.seatLabel ?? "Seat"
  } as IWLayoutSettings;
};

export const mapIWSettingsDTOToIWSettings = (data: IWSettingsDTO): IWSettings => {
  return {
    seatRequired: +(data.seat_required ?? 0),
    layout: mapLayoutSettings(data.layout),
    allowLogin: +(data.allow_login ?? 1),
    SingularVerbiage: data.singularVendorName,
    applePayEnabled: +data.apple_pay_enabled,
    displaySpecialInstructions: +(data.displaySpecialInstructions ?? 1),
    highlightColor: data.highlightColor,
    phoneNumberAtStart: +data.phoneNumberAtStart,
    pluralVendorName: data.pluralVendorName,
    showImages: +data.showImages,
    suppressTopLevelCategories: +data.suppressTopLevelCategories,
    url: data.url,
    useOrderingApi: +data.use_ordering_api,
    venueId: +data.venueId,
    rewardsAutoLookup: +data.rewards_auto_lookup,
    rewardsGuidanceText: data.rewards_guidance_text,
    rewardProviders:
      data.rewardProviders?.map((provider) => ({
        paymentType: provider.payment_type,
        subpaymentType: provider.subpayment_type,
        name: provider.provider_name
      })) ?? []
  };
};
